<template>
  <div>
    <center> <img src="https://www.toshstat.uz/images/toshstatlogo.png" style="max-height:80px;"/></center>
  </div>
  <p style="text-align:center; color:whitesmoke"><b>Toshkent shahar statistika <br> boshqarmasi</b></p>
</template>
